import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useBreadcrumb } from "../../../context/breadcrumb";
import { BreadcrumbActionType } from "../../../context/breadcrumb/reducer";
import VuiHelmet from "../../../components/helmet";
import ThirdPartyFormModule from "../../../modules/third-party/form";

const ThirdPartyFormPage = () => {
  const { t } = useTranslation();
  const { dispatch } = useBreadcrumb();
  const { id } = useParams();
  const metaTitle = id
    ? t("pages.thirdParty.detail.metaTitle")
    : t("pages.thirdParty.add.metaTitle");

  useEffect(() => {
    dispatch({
      type: BreadcrumbActionType.Update,
      payload: [
        {
          link: "/",
          title: t("common.text.home"),
        },
        {
          link: "/other-list",
          title: t("common.text.otherList"),
          isDisabled: true,
        },
        {
          link: "/third-party",
          title: t("common.text.thirdParty"),
        },
        {
          link: `/third-party/${id || "add"}`,
          title: id ? t("common.text.detail") : t("common.text.add"),
          isDisabled: true,
        },
      ],
    });
  }, [dispatch, t, id]);

  return (
    <>
      <VuiHelmet title={metaTitle} />

      <ThirdPartyFormModule />
    </>
  );
};

export default ThirdPartyFormPage;
